/**
 * Decoshop.ma - Shopify Online Store 2.0 Client Scripts
 * Architecture: Phase 3.3.1 - Content Accuracy, Hardened Sticky Bar & Verified Specifications
 * 
 * Rules:
 * - Direct routing to official Shopify /cart page (Cart Drawer permanently removed)
 * - 100% Free Shipping on all products (0 MAD, no threshold)
 * - Two dedicated WhatsApp channels (Orders: 212663039020 | Support: 212665881194)
 * - No 3M adhesive upsell or promotional adhesive popups; clean product page presentation
 * - Official Shopify checkout flow preserved
 */

document.addEventListener('DOMContentLoaded', function () {
  initAjaxCartForms();
  initProductGalleryGestures();
  initModalsA11y();
  initCartCounters();
});

/**
 * Moroccan Phone Utilities
 * Normalizes formats: 06XXXXXXXX, +2126XXXXXXXX, 2126XXXXXXXX to 212XXXXXXXXX
 */
function cleanMoroccoPhone(phone) {
  if (!phone) return '';
  var clean = phone.toString().replace(/[\s\+\-\.\(\)]/g, '');
  if (clean.startsWith('0')) {
    clean = '212' + clean.substring(1);
  } else if (clean.startsWith('00212')) {
    clean = clean.substring(2);
  }
  return clean;
}

function isValidMoroccoPhone(phone) {
  if (!phone) return false;
  var clean = phone.toString().replace(/[\s\+\-\.\(\)]/g, '');
  var moroccoRegex = /^(?:(?:\+|00)212|0)[5-7]\d{8}$/;
  return moroccoRegex.test(clean);
}

/**
 * Format Money in Moroccan Dirhams
 */
function formatMoroccoMoney(cents) {
  var dirhams = (cents / 100).toFixed(2);
  if (dirhams.endsWith('.00')) {
    dirhams = dirhams.slice(0, -3);
  }
  return dirhams + ' د.م.';
}

/**
 * Synchronize all cart counter elements across the page
 */
function initCartCounters() {
  fetch('/cart.js', {
    headers: { 'Accept': 'application/json' }
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart fetch error');
      return res.json();
    })
    .then(function (cart) {
      updateCartBadge(cart.item_count);
    })
    .catch(function () {
      // Graceful fallback
    });
}

function updateCartBadge(count) {
  if (count === null || count === undefined) return;
  var badges = document.querySelectorAll('#cart-counter-badge, .cart-counter-badge');
  badges.forEach(function (badge) {
    badge.textContent = count;
  });
}

/**
 * Robust AJAX Add-to-Cart with duplicate submission prevention,
 * network error handling, sold-out notifications, and DIRECT REDIRECT TO OFFICIAL /cart
 * (Phase 3.2: Replaces drawer opening with seamless /cart page navigation)
 */
function initAjaxCartForms() {
  var forms = document.querySelectorAll('form[action$="/cart/add"]');
  
  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var submitBtn = form.querySelector('[type="submit"][name="add"]');
      if (!submitBtn || submitBtn.disabled) return;

      // Prevent duplicate submissions immediately
      var originalBtnHtml = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.style.opacity = '0.7';
      submitBtn.innerHTML = '<span>⏳ جاري الإضافة...</span>';

      if (window.fetch && window.FormData) {
        e.preventDefault();
        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, status: res.status, data: data };
            });
          })
          .then(function (response) {
            if (!response.ok) {
              // Handle sold-out or limit exceeded
              submitBtn.disabled = false;
              submitBtn.style.opacity = '1';
              submitBtn.innerHTML = originalBtnHtml;
              var stickyCartBtn = document.getElementById('sticky-cart-btn');
              var stickyCartText = document.getElementById('sticky-cart-btn-text');
              if (stickyCartBtn) {
                stickyCartBtn.disabled = false;
                stickyCartBtn.style.opacity = '1';
                if (stickyCartText) stickyCartText.textContent = 'أضف للسلة';
              }
              var errorMsg = response.data.description || response.data.message || 'عذراً، تعذر إضافة المنتج لعدم توفر كمية كافية في المخزون.';
              showThemeToast('❌ ' + errorMsg, 'error');
              return;
            }

            // Success state - Redirect to official Shopify /cart page
            submitBtn.innerHTML = '<span>✅ تمت الإضافة! جاري التحويل إلى السلة...</span>';
            showThemeToast('🛒 تمت إضافة "' + (response.data.title || 'المنتوج') + '" بنجاح! جاري التحويل...', 'success');
            
            // Sync cart count badge
            initCartCounters();

            // Redirect immediately to official cart page
            var cartTargetUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
            setTimeout(function () {
              window.location.href = cartTargetUrl;
            }, 300);
          })
          .catch(function () {
            submitBtn.disabled = false;
            submitBtn.style.opacity = '1';
            submitBtn.innerHTML = originalBtnHtml;
            var stickyCartBtn = document.getElementById('sticky-cart-btn');
            var stickyCartText = document.getElementById('sticky-cart-btn-text');
            if (stickyCartBtn) {
              stickyCartBtn.disabled = false;
              stickyCartBtn.style.opacity = '1';
              if (stickyCartText) stickyCartText.textContent = 'أضف للسلة';
            }
            showThemeToast('⚠️ حدث خطأ في الاتصال، يرجى إعادة المحاولة.', 'error');
          });
      }
    });
  });
}

/**
 * Modals & Lightbox Accessibility (Escape key closes image zoom or mobile nav)
 */
function initModalsA11y() {
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeImageZoom();
      var navDrawer = document.getElementById('mobile-nav-drawer');
      if (navDrawer && navDrawer.style.display === 'block') {
        navDrawer.style.display = 'none';
      }
    }
  });
}

/**
 * Product Image Zoom & Lightbox
 */
function openImageZoom(imgSrc) {
  var modal = document.getElementById('product-image-zoom-modal');
  var zoomImg = document.getElementById('zoomed-image-target');
  if (modal && zoomImg) {
    zoomImg.src = imgSrc;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
}

function closeImageZoom() {
  var modal = document.getElementById('product-image-zoom-modal');
  if (modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
}

/**
 * Touch / Swipe Gestures for Mobile Gallery
 */
function initProductGalleryGestures() {
  var track = document.querySelector('.thumbnails-track');
  if (!track) return;
  // Smooth touch scrolling enabled natively via scroll-snap
}

/**
 * Accessible Toast Notification System
 */
function showThemeToast(message, type) {
  var existingToast = document.getElementById('theme-global-toast');
  if (existingToast) {
    existingToast.remove();
  }

  var toast = document.createElement('div');
  toast.id = 'theme-global-toast';
  toast.setAttribute('role', 'alert');
  toast.setAttribute('aria-live', 'polite');
  
  var isSuccess = type === 'success';
  var bgColor = isSuccess ? '#065f46' : '#991b1b';
  var borderColor = isSuccess ? '#10b981' : '#f87171';

  toast.style.cssText = 'position: fixed; top: 20px; inset-inline-end: 20px; z-index: 10000; background: ' + bgColor + '; color: #ffffff; border: 1.5px solid ' + borderColor + '; padding: 14px 20px; border-radius: 12px; font-size: 13px; font-weight: 800; box-shadow: 0 10px 25px rgba(0,0,0,0.25); max-width: 360px; line-height: 1.5; direction: rtl; text-align: right; animation: toastSlideIn 0.3s ease-out;';
  toast.textContent = message;

  document.body.appendChild(toast);

  setTimeout(function () {
    toast.style.opacity = '0';
    toast.style.transition = 'opacity 0.4s ease';
    setTimeout(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 400);
  }, 4000);
}

/* Phase 3.4.7: keep floating WhatsApp hidden from the beginning of the
   EasySell form through all content below it, including sticky COD buttons.
   Only reads layout/scroll; does not change EasySell submission or fields. */
(function () {
  if (!document.body || !document.body.classList.contains('template-product')) return;
  var target = null;
  var ticking = false;
  function update() {
    ticking = false;
    if (!target || !document.documentElement.contains(target)) {
      document.body.classList.remove('decoshop-cod-form-in-view');
      return;
    }
    var rect = target.getBoundingClientRect();
    document.body.classList.toggle('decoshop-cod-form-in-view', rect.top <= window.innerHeight);
  }
  function scheduleUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }
  function setup() {
    var inputs = Array.prototype.slice.call(document.querySelectorAll('input, textarea, select'));
    var field = inputs.find(function (el) {
      var hint = [el.getAttribute('placeholder'), el.getAttribute('name'), el.getAttribute('aria-label')].join(' ').toLowerCase();
      return /المدينة|أدخل المدينة|city|الاسم الكامل|رقم الهاتف/.test(hint);
    });
    if (!field) return false;
    target = field.closest('form') || field.closest('[class*="easysell" i]') || field.parentElement;
    if (!target || target === document.body) return false;
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    update();
    return true;
  }
  function start() {
    if (setup()) return;
    var attempts = 0;
    var poll = setInterval(function () {
      attempts += 1;
      if (setup() || attempts >= 30) clearInterval(poll);
    }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
